import { KEYS } from 'game/constants/SceneConstants';
import { SceneBase } from '@jollywise/jollygoodgame';
import { LEVELS } from '../constants/Constants';
import { FONT_BASE } from '../constants/AppFonts';
import { LevelSelectThumb } from '../display/ui/LevelSelectThumb';
import { ButtonClimateChampions } from '../display/ui/ButtonClimateChampions';

export default class LevelSelect extends SceneBase {
  constructor() {
    super({ key: KEYS.LevelSelect, active: false });
    // presistent active level so we can load where user left off
    this.activeLevelId = false;
  }

  create() {
    super.create();

    this.game.hud.setState('BASIC_HOME');
    this.setBackground('background_generic');

    this.add
      .text(840, 35, this.game.copy.get('title_levelselect').toUpperCase(), {
        font: `60px ${FONT_BASE.TITLE}`,
        color: '#ffffff',
        align: 'center',
      })
      .setOrigin(0.5, 0);

    this.gameTitle = this.add
      .text(840, 115, '{{GAME NAME}}', {
        font: `36px ${FONT_BASE.TITLE}`,
        color: '#ffffff',
        align: 'center',
      })
      .setOrigin(0.5, 0);

    // Level Thumbs
    this.levelThumbs = [];
    this.levelPagination = [];
    this.levelDisplaySpacing = 650;
    this.levelContainer = this.add.container();
    this.levelContainer.setPosition(840, 165);

    // pagination offset
    const paginationOffset = 840 - (LEVELS.length * 14 - 5) * 0.5;
    for (let p = paginationOffset, x = 0, i = 0; i < LEVELS.length; i++) {
      const data = LEVELS[i];

      // add level thumbnail
      const thumb = new LevelSelectThumb(this, data, this.game.model.getStars(LEVELS[i].id));
      thumb.x = x - thumb.width * 0.5;
      this.levelContainer.add(thumb);
      x += this.levelDisplaySpacing;
      this.levelThumbs.push(thumb);

      // thumb.on('pointerup', this.handlePlayLevel, this);
      // add level levelPagination
      const pagination = this.add.image(p, 650, 'shared_ui', 'pagination_01').setOrigin(0);
      this.levelPagination.push(pagination);
      p += 14;
    }

    // position level breadcrumbs

    // add play button
    this.btnPlay = new ButtonClimateChampions(this, {
      x: 840,
      y: 540,
      costume: 'btn_play_sml',
    });
    // this.btnPlay.once('pointerdown', this.handlePlayLevel, this);

    // add cycle buttons
    this.btnNext = new ButtonClimateChampions(this, {
      x: 1165,
      y: 360,
      costume: 'btn_forward',
      clickSFX: { sprite: 'general', id: 'general_whoosh' },
    });
    this.btnNext.on('pointerdown', this.handleNextLevel, this);
    this.btnPrev = new ButtonClimateChampions(this, {
      x: 515,
      y: 360,
      costume: 'btn_back',
      clickSFX: { sprite: 'general', id: 'general_whoosh' },
    });
    this.btnPrev.on('pointerdown', this.handlePrevLevel, this);

    this.input.on('pointerup', this.checkPointerUp, this);

    this.handleViewUpdate(this.getViewport());

    this.tweenToLevel(
      this.activeLevelId ? this.levelThumbs.findIndex((t) => t.id === this.activeLevelId) : 0,
      true
    );
  }

  get currentLevelIndex() {
    return Math.floor((840 - this.levelContainer.x) / this.levelDisplaySpacing);
  }

  checkPointerUp(e, gameobjects) {
    const dx = e.upX - e.downX;
    const dt = e.upTime - e.downTime;
    if (Math.abs(dx) > 192 && dt > 60 && dt < 300) {
      dx > 0 ? this.handlePrevLevel() : this.handleNextLevel();
    } else if (gameobjects.length) {
      if (gameobjects[0] != this.btnNext && gameobjects[0] != this.btnPrev) {
        const level = this.levelThumbs[this.currentLevelIndex].id;
        const config = LEVELS.find((l) => l.id === level);
        this.game.loadGame(config.id, config.loader);
      }
    }
  }

  handleNextLevel() {
    this.tweenToLevel(this.currentLevelIndex + 1);
    //  this.game.soundController.playSFX('general', 'general_whoosh');
  }

  handlePrevLevel() {
    this.tweenToLevel(this.currentLevelIndex - 1);
    //this.game.soundController.playSFX('general', 'general_whoosh');
  }

  tweenToLevel(index, instant) {
    if (index >= this.levelThumbs.length || index < 0) return;
    this.levelThumbs[this.currentLevelIndex].disable();
    this.btnPlay.visible = false;
    this.gameTitle.text = '';
    if (instant) {
      this.levelContainer.x = 840 - this.levelDisplaySpacing * index;
      this.activateLevel(index);
      this.btnPlay.visible = true;
    } else {
      this.tweens.add({
        targets: this.levelContainer,
        duration: 350,
        ease: Phaser.Math.Easing.Quadratic.Out,
        x: 840 - this.levelDisplaySpacing * index,
        onComplete: () => {
          this.btnPlay.visible = true;
          this.activateLevel(index);
        },
        onCompleteScope: this,
      });
    }
  }

  activateLevel(index) {
    const level = this.levelThumbs[index].id;
    const config = LEVELS.find((l) => l.id === level);
    this.activeLevelId = config.id;
    for (let i = 0; i < this.levelThumbs.length; i++) {
      if (i === index) this.levelThumbs[i].enable();
      else this.levelThumbs[i].disable();
      this.levelPagination[i].setFrame(i === index ? 'pagination_02' : 'pagination_01');
    }
    this.btnPrev.alpha = index > 0 ? 1 : 0.5;
    this.btnNext.alpha = index < this.levelThumbs.length - 1 ? 1 : 0.5;
    this.gameTitle.text = this.game.copy.get(`${config.id}_name`).toUpperCase();
  }

  shutdown() {
    super.shutdown();
  }
}
